import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';

import { valueToAbbreviation } from '../../libs/products';

import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import { sortTable, PureRecordRow } from '../../libs/utility';

import Table from '@material-ui/core/Table';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import DownloadIcon from '@material-ui/icons/CloudDownload';

import {
	getDocuments,
	invoiceStatusClassNames,
	statusToDisplay,
	moneyFormatter,
} from '../accounting/general';
import InvoiceDocumentIcon from '../../components/ui/invoiceDocumentIcon';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import InvoiceDocumentPopup from '../../components/Dialogs/InvoiceDocumentPopup';
import InvoicePdfPopup from '../../components/Dialogs/InvoicePdfPopup';
import ViewStationInvoiceLogDialog from '../../components/Dialogs/ViewStationInvoiceLogDialog';
import { post } from '../../modules/utility';
import AuthUserContainer from '../../containers/AuthUser';
import VendorBillContainer from '../../containers/billing/VendorBill';
import ConfirmInvalidateMissingBill from '../../components/Dialogs/ConfirmInvalidateMissingBill';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => {
	return {
		...invoiceStatusClassNames,
		paper: {
			width: '100%',
			//overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 25,
			paddingBottom: 30,
			marginTop: 10,
			[theme.breakpoints.up('md')]: {
				padding: '30px 40px 40px 40px',
			},
		},
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
	};
};

const stationColumns = [
	{
		id: 'stationInvoiceId',
		label: 'Invoice #',
		padding: 'checkbox',
	},
	{
		id: 'billsMissing',
		label: 'Bills Missing',
		padding: 'checkbox',
	},
	{
		id: 'deliveryInfo',
		label: 'Delivery Info',
		padding: 'checkbox',
	},
	{
		//id: 'invoiceTotal',
		id: 'issueDateSort',
		label: 'Invoice Info',
		padding: 'checkbox',
	},
	{
		id: 'invoiceInfo',
		label: 'Invoice Fuels',
		padding: 'checkbox',
	},
	{
		id: 'documentInfo',
		label: 'Documents',
		padding: 'checkbox',
	},
	{
		id: 'invoicePdf',
		label: 'Invoice PDF',
		padding: 'checkbox',
	},
	{
		id: 'quickbooksInvoiceUrl',
		label: 'QB Url',
		padding: 'checkbox',
	},
	{
		id: 'status',
		label: 'Status',
		padding: 'checkbox',
	},
	{
		id: 'edit',
		padding: 'checkbox',
		label: 'Edit',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class MissingStationAr extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			invoiceType: '',
			afterDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
			beforeDate: moment().subtract(1, 'week').format('YYYY-MM-DD'),
			searchResults: undefined,
			order: 'desc',
			orderBy: 'stationInvoiceId',
			isSearching: false,
			isInvalidateMissingBillDialogOpen: false,
			invalidatedCarrierPoNumberToInvoiceIds: [],
			invalidatedBolNumberToInvoiceIds: [],
		};
	}

	onChange = (value, path) => {
		const arrayPath = _.isString(path) ? _.toPath(path) : path;

		const val = _.isObject(value) && value.target ? value.target.value : value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value: this.getValue(path),
			error: this.getError(path),
			onChange: this.onChange,
			md: 6,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	submitGetMissingStationInvoices = () => {
		const { showErrors } = this.props;
		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		post({
			method: 'reconciliation.stationInvoices.getIncomplete',
			params,
			callback: (err, searchResults) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}

				//const searchResultRows = _.get(r, 'collections.stationInvoiceCollection', []);
				this.setState({
					savingStatus: 'done',
					searchResults,
					//searchResultBulkRows : undefined,
				});
			},
		});
	};

	getApiParams = () => {
		const { showErrors, accessToken } = this.props;
		const { afterDate, beforeDate } = this.state;

		const formFieldError = {};
		const requiredFields = [
			{ path: 'afterDate', label: 'After Date' },
			{ path: 'beforeDate', label: 'Before Date' },
		];

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);
		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		return {
			accessToken,
			afterDate: afterMoment.format('YYYY-MM-DD'),
			beforeDate: beforeMoment.format('YYYY-MM-DD'),
		};
	};

	invalidateMissingBill = ({ missingBill }) => {
		this.setState({
			isInvalidateMissingBillDialogOpen: true,
			missingBillForInvalidateDialog: missingBill,
		});
	};

	formatStationSearchResults = ({ searchResults }) => {
		const { invalidatedBolNumberToInvoiceIds, invalidatedCarrierPoNumberToInvoiceIds } = this.state;

		const c = searchResults.collections;

		const missingBolRows = _.get(c, 'bolNumberToInvoiceCollection', []);
		const missingCarrierRows = _.get(c, 'carrierPoNumberToInvoiceCollection', []);
		const stationInvoiceMap = _.keyBy(_.get(c, 'stationInvoiceCollection', []), 'stationInvoiceId');

		//const carrierPoNumberToInvoices = _.get(c, 'carrierPoNumberToInvoiceCollection', []);
		//const bolNumberToInvoices = _.get(c, 'bolNumberToInvoiceCollection', []);
		//const bulkInvoiceMap = _.keyBy(_.get(c, 'bulkInvoiceCollection', []), 'bulkInvoiceId');
		//const stationInvoiceMap = _.keyBy(_.get(c, 'stationInvoiceCollection', []), 'stationInvoiceId');
		const stationDeliveryMap = _.keyBy(
			_.get(c, 'stationDeliveryCollection', []),
			'stationDeliveryId'
		);
		//const bulkDeliveryMap = _.keyBy(_.get(c, 'bulkDeliveryCollection', []), 'bulkDeliveryId');
		const stationMap = _.keyBy(_.get(c, 'stationCollection', []), 'stationId');
		const carrierMap = _.keyBy(_.get(c, 'carrierCollection', []), 'carrierId');
		const terminalMap = _.keyBy(_.get(c, 'terminalCollection', []), 'terminalId');
		const supplierMap = _.keyBy(_.get(c, 'supplierCollection', []), 'supplierId');
		const invoiceDocumentMap = _.keyBy(
			_.get(c, 'invoiceDocumentCollection', []),
			'invoiceDocumentId'
		);
		//const resourceMap = _.keyBy(_.get(c, 'resourceCollection', []), 'resourceId');
		//const bulkCustomerMap = _.keyBy(_.get(c, 'bulkCustomerCollection', []), 'bulkCustomerId');

		//const rows = [];
		const missingByStationInvoiceId = {};

		missingBolRows.forEach((row) => {
			const { bolNumberToInvoiceId, stationInvoiceId, bolNumber, productType, supplierId } = row;

			if (_.includes(invalidatedBolNumberToInvoiceIds, bolNumberToInvoiceId)) {
				return;
			}

			if (!missingByStationInvoiceId[stationInvoiceId]) {
				missingByStationInvoiceId[stationInvoiceId] = {
					stationInvoiceId,
					billsMissing: [],
				};
			}

			const supplier = supplierMap[supplierId] || { name: 'Missing' };
			const productTypeAbbreviation = valueToAbbreviation(productType);

			const billDisplay = (
				<div style={{ marginLeft: 3 }}>
					<div>
						<strong>
							{productTypeAbbreviation} Bill from {supplier.name}
						</strong>
					</div>
					<div>BOL Number : {bolNumber}</div>
				</div>
			);

			const display = (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<div>
						<IconButton
							aria-label="clear"
							size="small"
							onClick={() => {
								this.invalidateMissingBill({
									missingBill: {
										bolNumberToInvoiceId,
										billDisplay,
									},
								});
							}}
						>
							<ClearIcon fontSize="small" />
						</IconButton>
					</div>
					{billDisplay}
				</div>
			);

			missingByStationInvoiceId[stationInvoiceId].billsMissing.push({
				bolNumber,
				productType,
				supplierId,
				display,
			});
		});

		missingCarrierRows.forEach((row) => {
			const { carrierPoNumberToInvoiceId, stationInvoiceId, carrierPoNumber, carrierId } = row;

			if (_.includes(invalidatedCarrierPoNumberToInvoiceIds, carrierPoNumberToInvoiceId)) {
				return;
			}

			if (!missingByStationInvoiceId[stationInvoiceId]) {
				missingByStationInvoiceId[stationInvoiceId] = {
					stationInvoiceId,
					billsMissing: [],
				};
			}

			const carrier = carrierMap[carrierId] || { name: 'Missing' };
			const billDisplay = (
				<div style={{ marginLeft: 3 }}>
					<div>
						<strong>Freight Bill from {carrier.name}</strong>
					</div>
					<div>Carrier PO Number : {carrierPoNumber}</div>
				</div>
			);

			const display = (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<div>
						<IconButton
							aria-label="clear"
							size="small"
							onClick={() => {
								this.invalidateMissingBill({
									missingBill: {
										carrierPoNumberToInvoiceId,
										billDisplay,
									},
								});
							}}
						>
							<ClearIcon fontSize="small" />
						</IconButton>
					</div>
					{billDisplay}
				</div>
			);

			missingByStationInvoiceId[stationInvoiceId].billsMissing.push({
				carrierPoNumber,
				carrierId,
				display,
			});
		});

		const finalRows = [];
		_.values(missingByStationInvoiceId).forEach((missing) => {
			const { stationInvoiceId, billsMissing } = missing;
			const stationInvoice = stationInvoiceMap[stationInvoiceId];
			if (!stationInvoice) {
				console.error(`Could not find stationInvoice using: ${stationInvoiceId}`);
				return;
			}
			const {
				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				//deliveryWindowEndDateTime,
				invoiceDocumentIds,
				issueDate,
				//dateCreated,
				collatedResourceId,
				quickbooksInvoiceUrl,
			} = stationInvoice;

			if (status === 'invalid') {
				return;
			}

			const station = stationMap[stationId] || { number: '', name: 'MISSING STATION' };
			const stationDisplay = `${station.number} - ${station.name}`;

			//- Delivery
			let stationDelivery;
			let deliveryInfo = <span>Not linked</span>;
			if (linkedStationDeliveryId) {
				stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
				if (!stationDelivery) {
					deliveryInfo = <span>Delivery {linkedStationDeliveryId} not found</span>;
				} else {
					const { deliveryWindowEndDateTime, stationDeliveryId } = stationDelivery;

					const dateDisplay = moment(deliveryWindowEndDateTime).format('ddd, M/D');
					deliveryInfo = (
						<Fragment>
							<div>{stationDisplay}</div>
							<div>Delivery #{stationDeliveryId}</div>
							<div>{dateDisplay}</div>
						</Fragment>
					);
				}
			}

			//- Station Invoice
			const invoiceDocuments = invoiceDocumentIds.map((invoiceDocumentId) => {
				return invoiceDocumentMap[invoiceDocumentId] || { name: 'MISSING' };
			});

			const { uploadedInvoiceDocuments, missingInvoiceDocuments } = getDocuments({
				stationDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});

			//- InvoiceInfo
			const invoiceLines = [];
			if (!_.isEmpty(missingInvoiceDocuments)) {
				invoiceLines.push('No documents yet');
			} else {
				const { products } = stationInvoice;
				if (_.isEmpty(products)) {
					invoiceLines.push('No fuels yet');
				} else {
					//let invoiceE85 = 0;
					products.forEach((product) => {
						const { productType, terminalSupplier, netGallons } = product;
						let terminalDisplay = 'No terminal yet';
						if (terminalSupplier) {
							const terminal = terminalMap[terminalSupplier.terminalId] || {
								name: `Missing terminal : ${terminalSupplier.terminalId}`,
							};
							terminalDisplay = terminal.name;
						}
						invoiceLines.push(`${netGallons} ${productType} : ${terminalDisplay}`);
						//invoiceE85 += parseInt(netGallons, 10);
					});
					//invoiceLines.push(<span><strong>{invoiceE85}</strong> gallons E85</span>);
				}
			}

			const carrier = carrierMap[carrierId] || { name: 'MISSING CARRIER' };
			let invoiceFuels = (
				<Fragment>
					<div>{carrier.name}</div>
					{invoiceLines.map((line, i) => {
						return <div key={i}>{line}</div>;
					})}
				</Fragment>
			);

			//- Documents
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			const statusDisplay = statusToDisplay[status] || status;

			let issueMoment = moment(issueDate);
			let issueDateSort = issueMoment.format('YYYY-MM-DD');
			let issueDateDisplay = issueMoment.format('ddd, M/D');

			let invoicePdf = 'PDF';
			let onInvoiceClick = () => {
				this.onInvoiceClick(collatedResourceId);
			};
			let invoiceTotal = <span>{moneyFormatter.format(stationInvoice.total)}</span>;
			let invoiceInfo = (
				<Fragment>
					<div>Issued : {issueDateDisplay}</div>
					<div>Total : {invoiceTotal}</div>
				</Fragment>
			);

			// for invoice search sometimes pending gets in there
			if (status === 'pending') {
				invoiceInfo = '';
				invoiceFuels = '';
			}

			finalRows.push({
				stationInvoiceId,
				billsMissing,
				deliveryInfo,
				issueDateSort,
				issueDateDisplay,
				invoiceTotal,
				invoiceInfo,
				invoiceFuels,
				documentInfo,
				invoicePdf,
				quickbooksInvoiceUrl,
				onInvoiceClick,
				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleRowClick(stationInvoiceId);
				},
			});
		});

		return finalRows;
	};

	getDocumentInfo = (uploadedInvoiceDocuments) => {
		const { classes } = this.props;
		const { searchResults } = this.state;

		const c = searchResults.collections;
		const resourceMap = _.keyBy(_.get(c, 'resourceCollection', []), 'resourceId');

		if (_.isEmpty(uploadedInvoiceDocuments)) {
			return 'None yet';
		}

		//- Documents
		let left = 0;
		let zIndex = 100;
		return (
			<div
				className={classes.invoiceDocumentContainer}
				onClick={() => {
					this.onDocumentClick(uploadedInvoiceDocuments);
				}}
			>
				{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
					left = i * 10;
					zIndex--;
					return (
						<div className={classes.invoiceDocument} style={{ left, zIndex }} key={i}>
							<InvoiceDocumentIcon
								hasTooltip={false}
								invoiceDocument={invoiceDocument}
								resourceMap={resourceMap}
								onClick={_.noop}
							/>
						</div>
					);
				})}
			</div>
		);
	};

	handleRowClick = (stationInvoiceId) => {
		const { searchResults } = this.state;
		if (!searchResults) {
			return;
		}

		const stationInvoices = _.get(searchResults, 'collections.stationInvoiceCollection', []);
		if (_.isEmpty(stationInvoices)) {
			return;
		}

		const viewStationInvoice = _.find(stationInvoices, { stationInvoiceId });
		this.setState({
			viewStationInvoice,
			isViewDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen: false,
			viewStationInvoice: undefined,
			bulkStationInvoice: undefined,
			isInvalidateMissingBillDialogOpen: false,
			missingBillForInvalidateDialog: undefined,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen: false,
			invoiceDocumentsPoppedUp: [],
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen: false,
			invoicePdfPoppedUp: undefined,
		});
	};

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen: true,
			invoiceDocumentsPoppedUp: invoiceDocuments,
		});
	};

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen: true,
			invoicePdfPoppedUp: resourceId,
		});
	};

	render() {
		const { classes } = this.props;

		const {
			searchResults,
			//searchResultBulkRows,
			isSearching,
		} = this.state;

		let resourceMap = {};
		if (searchResults) {
			resourceMap = _.keyBy(
				_.get(searchResults, 'collections.resourceCollection', []),
				'resourceId'
			);
		}

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'reconciliation.stationInvoices.getIncomplete',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline label="Find Station Invoices with Missing Vendor Bills" />
					<Paper className={classes.paper}>
						<FMPSectionHeader label={'Date Range'} isTop={true} />

						<FMPDatePicker
							label="Delivery Date After"
							format={'MMMM Do, YYYY'}
							{...this.getInputProps('afterDate')}
						/>

						<FMPDatePicker
							label="Delivery Date Before"
							format={'MMMM Do, YYYY'}
							{...this.getInputProps('beforeDate')}
						/>

						<Grid container spacing={3}>
							<Grid item md={8} style={{ paddingTop: 25, display: 'flex' }}>
								<Button
									className={classes.bigButton}
									variant="contained"
									color="primary"
									onClick={this.submitGetMissingStationInvoices}
								>
									<Search />
									RUN MISSING STATION AR SEARCH
								</Button>

								<a
									href={downloadUrl}
									style={{ textDecoration: 'none', paddingRight: 5 }}
									target="_blank"
									rel="noreferrer noopener"
								>
									<Button
										className={classes.bigButton}
										variant="contained"
										color="primary"
										style={{ marginLeft: 10 }}
									>
										<DownloadIcon className={classes.icon} style={{ marginRight: 5 }} /> Search &
										Download
									</Button>
								</a>

								{isSearching && (
									<div className={classes.runningSearch}>
										<CircularProgress />
										<span style={{ paddingLeft: 10 }}>Searching...</span>
									</div>
								)}
							</Grid>
						</Grid>
					</Paper>

					<Paper className={classes.paper}>
						{_.isUndefined(searchResults) && (
							<div className={classes.resultsHere}>Results here</div>
						)}

						{!_.isUndefined(searchResults) && this.renderResults()}
						{/* !_.isUndefined(searchResultBulkRows) && this.renderBulkResults() */}
					</Paper>
				</Grid>

				<InvoiceDocumentPopup
					open={this.state.isInvoiceDocumentPopupOpen}
					onClose={this.handleCloseInvoiceDocumentPopup}
					invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
					resourceMap={resourceMap}
				/>

				<InvoicePdfPopup
					open={this.state.isInvoicePdfPopupOpen}
					onClose={this.handleCloseInvoicePdfPopup}
					resourceId={this.state.invoicePdfPoppedUp}
					resourceMap={resourceMap}
				/>

				<ViewStationInvoiceLogDialog
					open={this.state.isViewDialogOpen}
					onClose={this.handleCloseViewDialog}
					stationInvoice={this.state.viewStationInvoice}
					history={this.props.history}
				/>

				<ConfirmInvalidateMissingBill
					open={this.state.isInvalidateMissingBillDialogOpen}
					onClose={this.handleCloseViewDialog}
					missingBill={this.state.missingBillForInvalidateDialog}
					afterSave={this.afterInvalidate}
					showErrors={this.props.showErrors}
				/>
			</Grid>
		);
	}

	afterInvalidate = ({ carrierPoNumberToInvoiceId, bolNumberToInvoiceId }) => {
		if (carrierPoNumberToInvoiceId) {
			this.setState({
				invalidatedCarrierPoNumberToInvoiceIds: [
					...this.state.invalidatedCarrierPoNumberToInvoiceIds,
					carrierPoNumberToInvoiceId,
				],
			});
		}

		if (bolNumberToInvoiceId) {
			this.setState({
				invalidatedBolNumberToInvoiceIds: [
					...this.state.invalidatedBolNumberToInvoiceIds,
					bolNumberToInvoiceId,
				],
			});
		}
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleEdit = (stationInvoiceId) => {
		this.props.history.push(`/accounting/stationInvoice/update/${stationInvoiceId}`);
	};

	renderResults = () => {
		const { canMakeUpdates, classes } = this.props;

		const { searchResults, order, orderBy } = this.state;

		const data = this.formatStationSearchResults({ searchResults });
		const issuedRows = sortTable({ data, order, orderBy });

		return (
			<Table size="small" className={classes.table}>
				<EnhancedTableHead
					columnData={stationColumns}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleSort}
				/>
				<TableBody>
					{issuedRows.map((row) => {
						return (
							<PureRecordRow hover className={classes.row} key={row.stationInvoiceId}>
								<TableCell onClick={row.rowClick}>{row.stationInvoiceId}</TableCell>
								<TableCell>
									{row.billsMissing.map((billMissing, i) => {
										const { display } = billMissing;
										return (
											<Fragment key={i}>
												{!!i && (
													<div
														style={{
															height: 3,
															marginTop: 2,
															borderTop: '1px dashed #ddd',
														}}
													/>
												)}
												<div>{display}</div>
											</Fragment>
										);
									})}
								</TableCell>
								<TableCell onClick={row.rowClick}>{row.deliveryInfo}</TableCell>
								<TableCell onClick={row.rowClick}>{row.invoiceInfo}</TableCell>
								<TableCell onClick={row.rowClick}>{row.invoiceFuels}</TableCell>
								<TableCell>{row.documentInfo}</TableCell>
								<TableCell>
									{row.status === 'issued' && (
										<div className={classes.invoiceIcon} onClick={row.onInvoiceClick} />
									)}
								</TableCell>

								<TableCell>
									{row.status === 'issued' && (
										<a href={row.quickbooksInvoiceUrl} target="_blank" rel="noreferrer noopener">
											<div className={classes.quickbooksIcon} />
										</a>
									)}
								</TableCell>

								<TableCell
									onClick={row.rowClick}
									className={classes[row.status]}
									style={{ whiteSpace: 'nowrap' }}
								>
									{row.statusDisplay}
								</TableCell>

								{canMakeUpdates && (
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										<Button
											className={classes.button}
											onClick={() => this.handleEdit(row.stationInvoiceId)}
										>
											Edit
										</Button>
									</TableCell>
								)}
							</PureRecordRow>
						);
					})}
				</TableBody>
			</Table>
		);
	};
}

MissingStationAr.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,
	accessToken: PropTypes.string,
};

export default _.flow([withStyles(styles), AuthUserContainer, VendorBillContainer])(
	MissingStationAr
);
